import React from 'react';
import LegalLayout from './LegalLayout';

const CookiePolicy = () => {
  return (
    <LegalLayout>
      <div className="container-standard px-4 max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
          <div className="flex justify-center items-center mb-6">
            <a href="/" className="text-primary-accent font-bold hover:underline text-lg">
                 ← Volver al Inicio
              </a>
            </div>
           <div className="text-center mb-4">
            <h1 className="text-display font-bold text-primary-dark">Política de Cookies</h1>
          </div>
          <p className="text-center text-gray-600 mb-8">Última actualización: Febrero 2026</p>

          <div className="prose prose-lg max-w-none">
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">1. ¿Qué son las cookies?</h2>
            <p className="mb-4">
              Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita un sitio web. Estos archivos contienen información que se utiliza para mejorar su experiencia de navegación y ofrecer servicios personalizados.
            </p>

            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">2. Tipos de cookies que utilizamos</h2>
            <p className="mb-4">
              Utilizamos diferentes tipos de cookies para diversos fines:
            </p>

            <h3 className="text-body-lg font-semibold text-primary-dark mb-2">Cookies estrictamente necesarias</h3>
            <p className="mb-4">
              Estas cookies son esenciales para que el sitio web funcione correctamente. Permiten funciones básicas como la navegación y el acceso a áreas seguras del sitio.
            </p>

            <h3 className="text-body-lg font-semibold text-primary-dark mb-2">Cookies de rendimiento</h3>
            <p className="mb-4">
              Recopilan información sobre cómo los usuarios utilizan el sitio web, como qué páginas visitan con mayor frecuencia y si reciben mensajes de error. Estas cookies no recopilan información que identifique al usuario.
            </p>

            <h3 className="text-body-lg font-semibold text-primary-dark mb-2">Cookies de funcionalidad</h3>
            <p className="mb-4">
              Permiten recordar elecciones que usted hace (como su nombre de usuario, idioma o región) y proporcionan características mejoradas y más personales.
            </p>

            <h3 className="text-body-lg font-semibold text-primary-dark mb-2">Cookies de publicidad</h3>
            <p className="mb-4">
              Se utilizan para mostrar anuncios relevantes para usted y sus intereses. También se utilizan para limitar el número de veces que ve un anuncio y ayudar a medir la efectividad de las campañas publicitarias.
            </p>

            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">3. Cómo gestionar las cookies</h2>
            <p className="mb-4">
              Puede controlar y/o eliminar las cookies según desee. Puede eliminar todas las cookies que ya se encuentran en su computadora y configurar la mayoría de los navegadores para que dejen de aceptarlas. Sin embargo, tenga en cuenta que si lo hace, es posible que tenga que ajustar manualmente algunas preferencias cada vez que visite un sitio y que algunos servicios y funcionalidades dejarán de funcionar.
            </p>

            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">4. Proveedores de servicios de terceros</h2>
            <p className="mb-4">
              Utilizamos servicios de terceros que pueden colocar cookies en nuestro sitio web para fines analíticos y publicitarios:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Herramientas de análisis web para entender cómo los usuarios interactúan con nuestro sitio</li>
              <li>Redes publicitarias para mostrar anuncios relevantes</li>
              <li>Proveedores de contenido social para facilitar el intercambio de contenido</li>
              <li>Proveedores de servicios de marketing para personalizar experiencias de usuario</li>
            </ul>

            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">5. Duración de las cookies</h2>
            <p className="mb-4">
              Las cookies pueden ser "persistentes" o "de sesión". Las cookies de sesión se eliminan cuando cierra su navegador. Las cookies persistentes permanecen en su dispositivo hasta que caducan o se eliminan manualmente.
            </p>

            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">6. Actualizaciones a esta política</h2>
            <p className="mb-4">
              Podemos actualizar esta Política de Cookies en cualquier momento. Le notificaremos sobre cambios significativos a través de nuestro sitio web. El uso continuado del sitio web después de la publicación de cambios constituye su aceptación de la política revisada.
            </p>

            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">7. Contacto</h2>
            <p className="mb-4">
              Si tiene preguntas sobre nuestra Política de Cookies, contáctenos en:
            </p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="font-medium">DAVID CORPORATION S.R.L. - DAVIDCORP S.R.L.</p>
              <p>RUC: 20602434011</p>
              <p>491 Jr. Sta Cruz de Pachacutec, Los Olivos, Lima, Perú</p>
              <p>Email: <a href="mailto:info@davidcorp-srl.com" className="text-primary-accent hover:underline">info@davidcorp-srl.com</a></p>
              <p>Teléfono: <a href="tel:+51936776570" className="text-primary-accent hover:underline">+51 936776570</a></p>
            </div>
          </div>
        </div>
      </div>
    </LegalLayout>
  );
};

export default CookiePolicy;